<template lang="pug">
  .reason-list-wrapper
    p.titulo-pagina regras de aprovação

    .barra-ferramentas
      .busca
        //- PSelect(v-model="tiposEvento" labelItem="name" title="selecionar tipo de evento")
        //- PSelect(v-model="statusEvento" labelItem="name" title="selecionar status")
        //- PButton(color="success" size="md" @click="buscarRegras") buscar
      .nova-regra
        PButton(color="warning" size="md" @click="createNewRule") criar nova regra

    SmartTable.table(name="approvalsrules-list" v-bind="table", v-model="tableData" ref="table")
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")
          template(v-slot:active="{ columnValue, rowItem, index }")
            .active
              .icon.fs-19.icon-ptt-icons-ativo.color-warning(v-if="columnValue === true")
              .icon.fs-19.icon-ptt-icons-inativo(v-else)

          template(v-slot:modelToCreate="{ rowItem }")
            span.text-container {{ parseEvent(rowItem) }}
          template(v-slot:companys="{ rowItem }")
            span(:title="parseDescricaoGeramento(rowItem)") {{ parseDescricaoGeramento(rowItem) }}
          template(v-slot:limiteAprovacoesMensalPorPerfil="{ rowItem }")
            span {{ parsePerfilQueResponde(rowItem) }}

      template(v-slot:detailsBox="{item}")
        Details(:rule="item", @reloadTable="updateTable")

</template>

<script>

import Details from './Details'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'ApprovalsRulesList',
  components: {Details},
  mounted () {
    this.updateTable()
    setAmplitudeEvent('lista regras de aprovação', {})
  },
  data () {
    return {
      reloadingApprovalRuleInfo: false,
      tiposEvento: {
        selected: null,
        loaded: [
          {id: 'Line', name: 'apontamento'},
          {id: 'FakeTimeLog', name: 'correção de ponto'},
          {id: 'AbstractJustify', name: 'dispensa'},
          {id: 'DayJourney', name: 'conversão de falta em bh'}
        ],
        loading: false
      },
      statusEvento: {
        selected: null,
        loaded: [
          {value: true, name: 'ativo'},
          {value: false, name: 'inativo'}
        ],
        loading: false
      },
      table: {
        headerItems: [
          {
            column: 'status',
            field: 'active',
            width: '0.2fr',
            options: [
              {iconClass: 'icon-ptt-icons-ativo', text: 'todas'},
              {iconClass: 'icon-ptt-icons-ativo', text: 'ativa'},
              {iconClass: 'icon-ptt-icons-inativo', text: 'inativa'}
            ],
            filterFunction: ({search, item}) => {
              if (search === 'todas') return true
              return search === 'ativa' ? item.active === true : item.active === false
            }
          },
          {column: 'nome da regra', field: 'name', width: '0.4fr'},
          {column: 'tipo de evento', field: 'modelToCreate', width: '0.25fr'},
          {column: 'quando é gerado', field: 'companys', width: '0.35fr'}, // TODO
          {column: 'quem responde', field: 'limiteAprovacoesMensalPorPerfil', width: '0.35fr'}
        ],
        config: {
          perPage: 10,
          startFocusedSearch: 'name',
          defaultSortField: 'name',
          defaultColumnSearch: 'name'
        }
      }
    }
  },
  computed: {
    tableData: {
      get () {
        return {
          loading: this.reloadingApprovalRuleInfo,
          loaded: this.$store.state.common.approvalsRules.items
        }
      }
    }
  },
  methods: {
    async buscarRegras () {
      await this.updateTable()
    },
    async updateTable (reloadAllRules = false) {
      this.reloadingApprovalRuleInfo = true
      this.closeDetailsTable()

      const params = {
        fullReload: reloadAllRules
        // type: this.tiposEvento.selected.id, - TODO
        // status: this.statusEvento.selected.id - TODO
      }
      await this.$store.dispatch('common/approvalsRules/fetchItems', params)

      this.reloadingApprovalRuleInfo = false
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    },
    createNewRule () {
      this.$router.push('/approvals-rules/new')
    },
    parseEvent (item) {
      const EVENT_CONVERTER = {
        'Line': 'apontamento',
        'FakeTimeLog': 'correção de ponto',
        'AbstractJustify': 'dispensa',
        'DayJourney': 'conversão de falta em bh'
      }
      return (EVENT_CONVERTER[item.modelToCreate])
    },
    parseDescricaoGeramento (regra) {
      const { employees, companys, groups, perfis } = regra

      if (employees.length > 0) {
        if (employees.length === 1) return `lançado para ${this.$ws('employee')} ${employees[0].name}`
        return `lançado para algum de ${employees.length} ${this.$wp('employee')}`
      } else if (companys.length > 0) {
        if (companys.length === 1) return `lançado para ${this.$ws('company')} ${companys[0].name}`
        return `lançado para algum de ${companys.length} ${this.$wp('company')}`
      } else if (groups.length > 0) {
        if (groups.length === 1) return `lançado para ${this.$ws('group')} ${groups[0].name}`
        return `lançado para algum de ${groups.length} ${this.$wp('group')}`
      } else if (perfis.length > 0) {
        if (perfis.length === 1) return `lançado pelo perfil ${perfis[0].name}`
        return `lançado por algum de ${perfis.length} perfis`
      }
    },
    parsePerfilQueResponde (regra) {
      const { limiteAprovacoesMensalPorPerfil, autoApprove, modelToCreate, somenteRh } = regra

      if (modelToCreate !== 'AbstractJustify') return '-'
      if (autoApprove) return 'aprovação automática'
      if (somenteRh) return 'somente RH'

      if (!limiteAprovacoesMensalPorPerfil || limiteAprovacoesMensalPorPerfil.length === 0) {
        return '-'
      } else if (limiteAprovacoesMensalPorPerfil.length === 1) {
        return limiteAprovacoesMensalPorPerfil[0].name_perfil
      } else {
        return `${limiteAprovacoesMensalPorPerfil.length} perfis`
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .reason-list-wrapper {
    display: grid;
    align-items: baseline;

    .titulo-pagina {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: bold;
      font-size: 25px;
      line-height: 2vh;
      text-align: center;
      color: 'primary';
      grid-column: 1/3;
    }

    .barra-ferramentas {
      margin-bottom: var(--header-margin-bottom);
      display: grid;
      align-items: center;
      grid-column: 1/3;
      grid-template-columns: auto 250px;
      gap: 20px;

      .busca {
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 300px 300px auto;
        align-items: center;
        gap: 5px;
      }
      .nova-regra {
        justify-self: right;
      }
    }

    .table {
      grid-column: 1/3;

      .flex {
        display: grid;
        grid-row-gap: 30px;
      }
    }
  }
</style>
